// extracted by mini-css-extract-plugin
export default {"root":"rangeColorCircle_root__F3kUY"};